<h2>Fall Risk Assessment</h2>
<assessment-row title="Age">
  <p>{{ data.fallRiskAge }}</p>
</assessment-row>
<assessment-row title="Fall History">
  <p>{{ hasFallHistory }}</p>
</assessment-row>
<assessment-row title="Elimination, Bowel and Urine">
  <p>{{ data.fallRiskEbu }}</p>
</assessment-row>
<assessment-row title="Medications" description="Includes PCA/opiates, anticonvulsants,
  anti-hypertensives, diuretics, hypnotics, laxatives, sedatives, and psychotropics">
  <p>{{ data.fallRiskMedications }}</p>
</assessment-row>
<assessment-row title="Patient Care Equipment" description="Any equipment that
  tethers patient (e.g. IV infusion, chest tube, indwelling catheter, SCDs, etc.)">
  <p>{{ data.fallRiskPce }}</p>
</assessment-row>
<assessment-row title="Mobility">
  <emr-list [list]="data.fallRiskMobility"></emr-list>
</assessment-row>
<assessment-row title="Cognition">
  <emr-list [list]="data.fallRiskCognition"></emr-list>
</assessment-row>
<assessment-row title="Total Fall Risk Score" description="Sum of all points per category">
  <p>{{ data.fallScore }}</p>
</assessment-row>
<assessment-row title="Fall Risk">
  <p>{{ fallRiskCategory }}</p>
</assessment-row>

<assessment-row title="Mobility">
  <p>{{ data.mobilityAndTransfers }}</p>
</assessment-row>
<assessment-row title="Assistive Devices">
  <emr-list [list]="data.assistiveDevices" emptyText="None"></emr-list>
</assessment-row>

<assessment-row title="Limited Range of Motion">
  <p>{{ data.limitedRangeOfMotion }}</p>
</assessment-row>

<assessment-row title="Deformities Present">
  <p>{{ data.deformitiesPresent }}</p>
</assessment-row>